<template>
  <v-dialog v-model="formValue" v-bind="$attrs">
    <slot name="extra"></slot>
    <v-card v-if="showCard">
      <v-toolbar dark color="primary">
        <v-toolbar-title>
          <slot name="title"></slot>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="close" dark :disabled="disableClose">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-progress-linear indeterminate v-if="loading"></v-progress-linear>
      <slot name="alert"></slot>
      <v-card-text>
        <slot name="text"></slot>
      </v-card-text>
      <v-card-actions>
        <slot name="actions"></slot>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    props: {
      value: {
        type: Boolean,
        required: true,
      },
      disableClose: {
        type: Boolean,
        default: false,
      },
      loading: {
        type: Boolean,
        default: false,
      },
      showCard: {
        type: Boolean,
        default: true,
      },
    },
    data() {
      return {
        formValue: false,
      }
    },
    watch: {
      value(v) {
        this._updateFormValue(v)
      },
      formValue(v) {
        this._emitChange(v)
      },
    },
    methods: {
      _updateFormValue(v) {
        this.formValue = v
      },
      _emitChange(v) {
        this.$emit('input', v)
      },
      close() {
        this._emitChange(false)
      },
    },
    mounted() {
      this._updateFormValue(this.value)
    },
  }
</script>

<style scoped>
</style>